<template>
<div id="about-bossMessage" class="boss-message" data-aos="fade-left" :data-aos-duration="1500">
  <div class="boss-message-row container">
    <div class="boss-message-left">
      <el-image
          style="width: 100%; height: 100%"
          src="http://www.energyst.cn/media/article/images/董事长_20230608161050_623.jpg"
          lazy>
      </el-image>
    </div>
    <div class="boss-message-right">
      <h1>董事长寄语</h1>
      <span>——</span>
      <p> 自创立恩莱吉以来，我公司一直秉承诚信、创新及科学经营的理念，以人才为基础，以高新技术为依托，以服务为保障，以资本运营为纽带，通过不断的创新研发和技术提升，向不同的客户提供个性化的水利水电技术综合服务和节能产品。发展至今，我公司已成为集工程咨询、设计、采购、施工和产品研发为一体的综合性高新技术企业，并逐渐迈向集团化、多元化和国际化。开拓创新、科学管理、回报社会是恩莱吉人的核心创业精神。 恩莱吉人以产业报国和技术齐家为己任，通过自己的“修业”，为能源科技进步及创造节能、环境友好型社会作出贡献。</p>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: "BossMessage"
}
</script>

<style scoped lang="less">
.boss-message {

  .boss-message-row {
    display: flex;
    justify-content: space-between;
    padding: 80px 0;
    height: 400px;

    .boss-message-right {
      padding: 20px 0;
      height: 100%;
      width: 500px;
      box-sizing: border-box;

      h1 {
        font-size: 30px;
      }

      span {
        font-size: 30px;
        color: #1E55AE;
      }

      p {
        font-size: 16px;
        line-height: 35px;
      }
    }

    .boss-message-left {
      width: 600px;
      height: 100%;
      background-color: #8C8C8C;

      img {
        //&:hover {
        //  cursor: url('~@/assets/images/magnifier.png'), default;
        //}
      }
    }

  }
}
</style>